export default (list) => {
  const roles = list.map(role => {
    if (window.allowedRoles.map(x => x.role).includes(role.name)) {
      return role
    }
  }).filter(Boolean)
  return roles
}
